import React, { useEffect, lazy, Suspense } from "react";
import MenuHeader from "./MenuHeader";
import { useMainMenu } from "../hooks/use-main-menu";
import HomeScreen from "../sections/home";
import { MENU_SCREEN } from "../menu.types";
import logo from "../assets/images/logo.png";
import { ALL_SECTION_IMAGES } from "../preload-images";
import Dialog from "./dialog";

// Lazy-load every screen except Home so the JS for unused screens is parsed
// only on first visit, not at menu open. In FiveM/CEF, even local JS parsing
// adds measurable startup latency on lower-end hardware.
const ProfileScreen = lazy(() => import("../sections/profile"));
const JobsScreen = lazy(() => import("../sections/jobs"));
const SettingsScreen = lazy(() => import("../sections/settings"));
const MissionsScreen = lazy(() => import("../sections/missions"));
const ShopScreen = lazy(() => import("../sections/shop"));
const VipScreen = lazy(() => import("../sections/vip/index"));
const OtherScreen = lazy(() => import("../sections/other"));
const OrganizationsScreen = lazy(() => import("../sections/organizations"));
const BackpacksScreen = lazy(() => import("../sections/backpacks"));
const VehiclesScreen = lazy(() => import("../sections/vehicles"));
const MoneyPackagesScreen = lazy(() => import("../sections/money-packages"));
const ReferralScreen = lazy(() => import("../sections/referral"));
const ContainersScreen = lazy(() => import("../sections/containers"));
const RulesScreen = lazy(() => import("../sections/rules"));
const HaineScreen = lazy(() => import("../sections/haine"));
const AnimatiiScreen = lazy(() => import("../sections/animatii"));
const WikiScreen = lazy(() => import("../sections/wiki"));
const Report = lazy(() => import("../sections/report"));
const VouchersScreen = lazy(() => import("../sections/vouchers"));

function preloadImages(srcs: string[]) {
  srcs.forEach((src) => {
    const img = new Image();
    img.src = src;
    img.decode().catch(() => {});
  });
}

interface Props {
  className?: string;
}

const MainMenu: React.FC<Props> = ({ className }) => {
  const { heading, activeScreen, apoints, previousScreen, back } =
    useMainMenu();

  useEffect(() => {
    preloadImages(ALL_SECTION_IMAGES);
  }, []);

  return (
    <main className={`bebas-neue-font flex flex-col ${className}`}>
      <img
        src={logo}
        alt="Atlantis RP Logo"
        className="absolute top-0 left-[50%] translate-x-[-50%] w-full max-w-[200px]"
      />

      <MenuHeader
        apoints={apoints}
        titleWords={heading.titleWords}
        description={heading.description}
        previousScreen={
          activeScreen !== MENU_SCREEN.Home ? previousScreen : undefined
        }
        onBack={back}
      />

      <main className="flex-1 min-h-0 mt-4  3440px:pt-4">
        {activeScreen === MENU_SCREEN.Home && <HomeScreen />}
        <Suspense fallback={null}>
          {activeScreen === MENU_SCREEN.Profile && (
            <ProfileScreen
              fullname="Megu Atlantis"
              username="Megumin0202"
              bank={43730}
              cash={25060}
              email="mario00ripar@gmail.com"
              status={1}
              accTime={1773324335}
              level={24}
              exp={17689}
              factionName="Police Department"
              factionRank={10}
              registerdate={1699798889}
              houseId="1"
              hoursPlayed={749}
              recoil={300}
              garageCapacity={`52 (*20)`}
              rang={"Text"}
              marriedToId={4}
            />
          )}
          {activeScreen === MENU_SCREEN.Jobs && <JobsScreen />}
          {activeScreen === MENU_SCREEN.Settings && <SettingsScreen />}
          {activeScreen === MENU_SCREEN.Missions && <MissionsScreen />}
          {activeScreen === MENU_SCREEN.Shop && <ShopScreen />}
          {activeScreen === MENU_SCREEN.Vip && <VipScreen />}
          {activeScreen === MENU_SCREEN.Other && <OtherScreen />}
          {activeScreen === MENU_SCREEN.Organizations && (
            <OrganizationsScreen />
          )}
          {activeScreen === MENU_SCREEN.Backpacks && <BackpacksScreen />}
          {activeScreen === MENU_SCREEN.Vehicles && <VehiclesScreen />}
          {activeScreen === MENU_SCREEN.MoneyPackages && (
            <MoneyPackagesScreen />
          )}
          {activeScreen === MENU_SCREEN.Referral && <ReferralScreen />}
          {activeScreen === MENU_SCREEN.Containers && <ContainersScreen />}
          {activeScreen === MENU_SCREEN.Rules && <RulesScreen />}
          {activeScreen === MENU_SCREEN.Haine && <HaineScreen />}
          {activeScreen === MENU_SCREEN.Animatii && <AnimatiiScreen />}
          {activeScreen === MENU_SCREEN.Wiki && <WikiScreen />}
          {activeScreen === MENU_SCREEN.Report && <Report />}
          {activeScreen === MENU_SCREEN.Vouchers && <VouchersScreen />}

          {/*   <Dialog
          title={"Confimare"}
          description={"test"}
          placeholder={"placholder"}
          onSubmit={() => {}}
        /> */}
        </Suspense>
      </main>
    </main>
  );
};

export default MainMenu;
